import { Box, Card, CardContent, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@material-ui/core";
import DialogComponent from "../../../components/Dialog"
import { getTranslation } from "../../../heplers/translationHelper";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import ButtonWithLoading from "../../../components/ButtonWithLoading";
import { useEffect, useState } from "react";
import { Get, Post } from "../../../actions";
import { useSnackbar } from "notistack";
import { DatePicker } from "../../../components/DatePicker";
import dayjs from "dayjs";
import MonthYearPicker from "../../../components/MonthYearPicker";
import LocaleNumberField from "../../../components/LocaleNumberField";
import { IndexationDetails } from "../../tanents/components/details/components/IndexationDetails";
import { Get_Tanenet_URL, Post_ConfirmIndexationProposals_URL } from "../../../constants/apiUrls";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

// round a computed value to 2 decimals, returning a canonical Number (never a
// locale-ambiguous toFixed string that would be re-parsed incorrectly later).
const to2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export const ConfirmIndexationDialog = ({ open, proposal, onClose, onConfirmed }) => {
    const [indexationProposal, setIndexationProposal] = useState({
        startDate: null,
        oldIndex: 0,
        newIndex: 0,
        newProposal: 0,
        oldRent: 0,
        newRent: 0,
        month: dayjs().month() - 1,
        year: dayjs().year() + 1,
        percentage: 100,
        baseCode: 2013,
        additionalPayments: []

    });
    const { enqueueSnackbar } = useSnackbar();
    const [tenant, setTenant] = useState();


    const getTenant = (values) => {
        Get(
            { tenantId: values },
            Get_Tanenet_URL,
            null,
            (resp) => {
                setTenant(resp?.data);
            },
            (error) => {
                enqueueSnackbar(error?.data, { variant: "error" });
            }
        );
    };

    useEffect(() => {
        if (!open || !proposal) return;
        getTenant(proposal.tenantId);
        // the cron computed the new index from the month preceding the contract anniversary
        var date = dayjs(proposal.startDate).add(-1, "month");
        setIndexationProposal({
            startDate: proposal.contractStartDate ? proposal.contractStartDate.slice(0, 10) : null,
            oldIndex: proposal.oldIndex,
            newIndex: proposal.newIndex,
            newProposal: proposal.newProposal,
            oldRent: proposal.oldRent,
            newRent: proposal.newRent,
            percentage: proposal.percentage,
            month: date.month() + 1,
            year: date.year(),
            baseCode: proposal.baseCode ? proposal.baseCode : 2013,
            additionalPayments: []
        });
        loadIndexationProposal(date.month() + 1, date.year(), proposal.baseCode ? proposal.baseCode : 2013, true);
    }, [open, proposal]);

    const loadIndexationProposal = (month, year, baseCode, initial) => {
        if (proposal?.contractStartDate)
            Post(
                { tenantId: proposal.tenantId, startDate: dayjs(proposal.contractStartDate).format("YYYY-MM-DD"), month: month, year: year, baseCode: baseCode },
                "Indexation/GetNewIndexationProposal",
                null,
                (resp) => {
                    if (initial) {
                        // keep the cron-generated figures the user saw in the list;
                        // the fetch only supplies additional payments and picker defaults
                        setIndexationProposal({
                            ...resp.data,
                            oldIndex: proposal.oldIndex,
                            newIndex: proposal.newIndex,
                            newProposal: proposal.newProposal,
                            oldRent: proposal.oldRent,
                            newRent: proposal.newRent,
                            percentage: proposal.percentage,
                        });
                    } else {
                        setIndexationProposal(resp.data);
                    }
                },
                (error) => {
                    enqueueSnackbar(
                        getTranslation(
                            "Something went wrong. Please contact with admin.",
                            "Something went wrong. Please contact with admin.",
                            "Something went wrong. Please contact with admin."
                        ),
                        {
                            variant: "error",
                        }
                    );
                }
            );
    };


    return <DialogComponent
        maxWidth="lg"
        title={getTranslation("Review & Confirm Indexation", "Review & Confirm Indexation", "Review & Confirm Indexation")}
        open={open}
        onClose={() => {
            onClose();
        }}
    >
        <Card>
            <CardContent>
                <Formik
                    enableReinitialize
                    initialValues={indexationProposal}
                    validationSchema={Yup.object({
                        oldIndex: Yup.number().required("Required"),
                        newIndex: Yup.number().required("Required"),
                        newProposal: Yup.number().required("Required"),
                        oldRent: Yup.number().required("Required"),
                        newRent: Yup.number().required("Required"),
                        percentage: Yup.number().required("Required")
                    })}
                    onSubmit={(values, actions) => {
                        Post(
                            {
                                confirmedProposals: [{
                                    contractId: proposal.contractId,
                                    newRent: Number(values.newRent),
                                    percentage: Number(values.percentage),
                                    oldIndex: Number(values.oldIndex),
                                    newIndex: Number(values.newIndex),
                                    newProposal: Number(values.newProposal),
                                    oldRent: Number(values.oldRent),
                                }]
                            },
                            Post_ConfirmIndexationProposals_URL,
                            null,
                            resp => {
                                enqueueSnackbar(
                                    getTranslation(
                                        "Indexation is successfully confirmed",
                                        "Indexation is successfully confirmed",
                                        "Indexation is successfully confirmed"
                                    ),
                                    { variant: "success" }
                                );
                                actions.setSubmitting(false)
                                onConfirmed()
                            },
                            error => {
                                enqueueSnackbar(error?.data, { variant: "error" })
                                actions.setSubmitting(false)

                            }
                        )
                    }}
                >
                    {({
                        errors,
                        touched,
                        values,
                        handleSubmit,
                        isSubmitting,
                        getFieldProps,
                        setFieldValue,
                    }) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={6} lg={6}>

                                    <Typography
                                        variant="subtitle1"
                                        style={{
                                            fontWeight: 600,
                                            marginBottom: 8,
                                            color: "#374151",
                                        }}
                                    >
                                        {getTranslation("Base Code", "Base Code", "Base Code")}
                                    </Typography>
                                    <ToggleButtonGroup
                                        exclusive
                                        value={values.baseCode}
                                        onChange={(e, newBaseCode) => {
                                            if (!newBaseCode) return;
                                            setFieldValue("baseCode", newBaseCode);
                                            loadIndexationProposal(values.month, values.year, newBaseCode)
                                        }}
                                    >
                                        <ToggleButton value={1988}>1988</ToggleButton>
                                        <ToggleButton value={1996}>1996</ToggleButton>
                                        <ToggleButton value={2004}>2004</ToggleButton>
                                        <ToggleButton value={2013}>2013</ToggleButton>
                                    </ToggleButtonGroup>

                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Box display="flex" justifyContent="flex-end">

                                        <Box component={Paper} borderRadius={2} boxShadow={3} p={2}>

                                            <TableContainer>
                                                <Table size="small" style={{
                                                    borderCollapse: "collapse",
                                                }}>
                                                    <TableBody>
                                                        <TableRow style={{
                                                            borderCollapse: "collapse",
                                                            border: 'none'
                                                        }}>
                                                            <TableCell style={{ fontWeight: 600, width: "40%", border: 'none' }} >Apartment No:</TableCell>
                                                            <TableCell style={{ border: 'none' }}>{tenant?.apartmentNo}</TableCell>
                                                        </TableRow>

                                                        <TableRow style={{
                                                            borderCollapse: "collapse",
                                                        }}>
                                                            <TableCell style={{ fontWeight: 600, border: 'none' }}>Address:</TableCell>
                                                            <TableCell style={{ border: 'none' }}>{tenant?.aparmentAddress}</TableCell>
                                                        </TableRow>

                                                        <TableRow style={{
                                                            borderCollapse: "collapse",
                                                        }}>
                                                            <TableCell style={{ fontWeight: 600, border: 'none' }}>PEB:</TableCell>
                                                            <TableCell style={{ border: 'none' }}>{tenant?.aparmentPEB}</TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <DatePicker
                                        disabled
                                        label="Contract Start Date"
                                        value={values.startDate}
                                        required
                                        onChange={(newDate) => {
                                            setFieldValue("startDate", newDate);
                                        }}
                                        size='small'
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <MonthYearPicker
                                        value={{ month: values.month, year: values.year }}
                                        initialDate={values.startDate}
                                        onMonthChange={(m) => {
                                            loadIndexationProposal(m, values.year, values.baseCode)
                                            setFieldValue("month", m)
                                        }}
                                        onYearChange={(y) => {
                                            loadIndexationProposal(values.month, y, values.baseCode)
                                            setFieldValue("year", y)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <LocaleNumberField
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                        name="oldIndex"
                                        label="Old Index"
                                        value={values.oldIndex}
                                        onChange={(e) => {
                                            const oldIndex = e.target.value;
                                            const newRent = to2((oldIndex * values.newRent) / values.oldIndex);
                                            setFieldValue("newRent", newRent)
                                            setFieldValue("oldIndex", oldIndex)
                                        }}
                                        error={touched.oldIndex && Boolean(errors.oldIndex)}
                                        helperText={touched.oldIndex && errors.oldIndex}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LocaleNumberField
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                        name="newIndex"
                                        label="New Index"
                                        value={values.newIndex}
                                        onChange={(e) => {
                                            const newIndex = e.target.value;
                                            const newRent = to2((values.oldRent * newIndex) / values.oldIndex);
                                            setFieldValue("newRent", newRent)
                                            setFieldValue("newIndex", newIndex)
                                        }}
                                        error={touched.newIndex && Boolean(errors.newIndex)}
                                        helperText={touched.newIndex && errors.newIndex}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LocaleNumberField
                                        size='small'
                                        variant='outlined'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                        name="percentage"
                                        label="Percentage"
                                        value={values.percentage}
                                        onChange={(e) => {
                                            const percentage = e.target.value;
                                            const newRent = to2((values.newProposal - values.oldRent) * (percentage / 100) + values.oldRent)
                                            setFieldValue("newRent", newRent)
                                            setFieldValue("percentage", percentage)
                                        }}
                                        error={touched.percentage && Boolean(errors.percentage)}
                                        helperText={touched.percentage && errors.percentage}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={12} md={12}>
                                    <IndexationDetails
                                        fundsArray={values.additionalPayments}
                                        oldRent={values.oldRent}
                                        newRent={values.newRent}
                                        percentage={values.percentage}
                                        increaseAmount={(values.newProposal - values.oldRent)*(values.percentage/100.00)}
                                    />

                                </Grid>

                            </Grid>
                            <Box
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                }}
                            >
                                <ButtonWithLoading
                                    title={
                                        <Typography
                                            variant="h5"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            {getTranslation(
                                                "Confirm",
                                                "Confirm",
                                                "Confirm"
                                            )}
                                        </Typography>
                                    }
                                    size="small"
                                    variant="contained"
                                    loading={isSubmitting}
                                    onClick={handleSubmit}
                                    style={{
                                        boxShadow: "4px 4px 10px 0px rgba(0, 0, 0, 0.1)",
                                        padding: "12px 10px 12px 8px",
                                        background: "rgb(251,94,57)",
                                        display: values.newRent == 0 ? "none" : "",
                                        borderRadius: "20px",
                                        width: "230px",
                                    }}
                                />
                            </Box>
                        </Form>
                    )}
                </Formik>

            </CardContent>
        </Card>
    </DialogComponent>
}
